import {ValueObject} from '@s-ui/domain'

import {FiltersGroupsListSearchValueObject} from './FiltersGroupsListSearchValueObject.js'

export class FiltersConfigSearchValueObject extends ValueObject {
  #config

  constructor({config}) {
    super()
    this.#config = config
  }

  static create({config}) {
    return new FiltersConfigSearchValueObject({config})
  }

  static createFromSearch({search, type}) {
    return new FiltersConfigSearchValueObject({
      config: FiltersGroupsListSearchValueObject.createFromSearch({search, type})
    })
  }

  get value() {
    return this.#config.value
  }

  toJSON() {
    return {
      config: this.#config.toJSON()
    }
  }
}
